import React from "react";
import { CalendarDay } from "../../calendar/utils";
import { getEvensongLiturgy } from "../../liturgy/evensong";
import { LiturgyViewer } from "../../liturgy/LiturgyViewer";
import { useDataDependency } from "../../utils/RemoteDataProvider";
import {
    getEveningReadingsFromMorningReadings,
    LessonData,
    useSettings,
} from "../../utils/settings";
import { useTrackPray } from "../../utils/tracking";

export const Evensong: React.FC<{ day: CalendarDay; isToday: boolean }> = (
    props
) => {
    const { day } = props;

    const { settings, setSetting } = useSettings();

    useTrackPray(day, "evensong");

    const loadablePsalms = useDataDependency<string[]>({
        type: "proper psalms",
        day,
        psalmCycle: settings.psalmCycle,
        time: "evening",
    });

    const loadableLessons = useDataDependency<{
        firstLesson: LessonData;
        secondLesson: LessonData;
    }>({
        type: "evensong readings",
        day,
        evensongReadings: getEveningReadingsFromMorningReadings(
            settings.mattinsReadings
        ),
        bibleTranslation: settings.bibleTranslation,
        refsOnly: false,
    });

    return (
        <>
            <LiturgyViewer
                items={getEvensongLiturgy(
                    day,
                    settings,
                    loadablePsalms,
                    loadableLessons
                )}
            />
        </>
    );
};
